<template>
  <sf-dialog model-value :width="300" persistent>
    <v-card>
      <v-card-item>
        <v-card-title>
          <sf-heading>{{ $t('checkoutExpiredDialog.title') }}</sf-heading>
        </v-card-title>
      </v-card-item>
      <v-card-text class="d-flex flex-column align-center text-justify">
        <v-icon :icon="mdiBellRing" size="56" color="grey-lighten-1" />
        <sf-text>{{ $t('checkoutExpiredDialog.description') }}</sf-text>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <sf-text-button :loading="loading" color="primary" @click="$emit('refresh')">
          {{ $t('checkoutExpiredDialog.buttonCaption') }}
        </sf-text-button>
      </v-card-actions>
    </v-card>
  </sf-dialog>
</template>

<script setup lang="ts">
import SfTextButton from '@/components/button/SfTextButton.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import SfText from '@/components/text/SfText.vue'
import SfDialog from '@/components/dialog/SfDialog.vue'
import { mdiBellRing } from '@mdi/js'

defineProps({
  loading: {
    type: Boolean,
    default: false
  }
})
defineEmits(['refresh'])
</script>
